var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("img", {
        staticStyle: { width: "100vw", height: "calc(100vh - 60px)" },
        attrs: { src: _vm.signImg ? _vm.signImg : _vm.img, alt: "" },
      }),
    ]),
    _c(
      "div",
      {
        staticStyle: {
          position: "fixed",
          top: "0",
          right: "0",
          width: "100vw",
          height: "100vh",
          "z-index": "9999",
        },
      },
      [
        _c("canvas", {
          ref: "signHandle",
          staticClass: "canvas",
          staticStyle: { border: "1px solid #ccc", "box-sizing": "border-box" },
        }),
        _c(
          "div",
          {
            staticStyle: {
              "text-align": "center",
              height: "55px",
              "background-color": "#fff",
              "margin-top": "5px",
            },
          },
          [
            _c(
              "el-button",
              { attrs: { size: "mini" }, on: { click: _vm.closeHandle } },
              [_vm._v("取消")]
            ),
            _c(
              "el-button",
              { attrs: { size: "mini" }, on: { click: _vm.clearHandle } },
              [_vm._v("清空")]
            ),
            _vm.useSing
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.ClickUseSing },
                  },
                  [_vm._v("使用预制签名")]
                )
              : _vm._e(),
            _c(
              "el-button",
              {
                attrs: {
                  size: "mini",
                  type: "primary",
                  disabled: _vm.changeNum === 0,
                },
                on: { click: _vm.onComfirm },
              },
              [_vm._v("确认")]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }